(function () {
  // Only run on pages that contain the register or login section
  if (!document.querySelector(".register") && !document.querySelector(".login")) return;

  // Find password groups on the page
  const groups = document.querySelectorAll(
    ".input-group.data-password .password-field"
  );
  if (!groups.length) return;

  groups.forEach((group) => {
    const input = group.querySelector(
      'input[type="password"], input[type="text"]'
    );
    const toggle = group.querySelector(".password-toggle");
    const icon = toggle ? toggle.querySelector("img") : null;
    const openSrc = toggle ? toggle.getAttribute("data-eye-open") : null;
    const closedSrc = toggle ? toggle.getAttribute("data-eye-closed") : null;

    if (!input || !toggle || !icon || !openSrc || !closedSrc) return;

    toggle.addEventListener("click", () => {
      const isHidden = input.type === "password";

      input.type = isHidden ? "text" : "password";
      toggle.setAttribute("aria-pressed", String(isHidden));

      // Swap eye icon + accessible label
      if (isHidden) {
        // hidden -> visible
        icon.setAttribute("src", openSrc);
        icon.setAttribute("alt", "Hide password");
        toggle.setAttribute("aria-label", "Hide password");
      } else {
        // visible -> hidden
        icon.setAttribute("src", closedSrc);
        icon.setAttribute("alt", "Show password");
        toggle.setAttribute("aria-label", "Show password");
      }
    });
  });
})();

const resetPwdBtn = document.querySelector(".reset-pwd-btn");

if( resetPwdBtn ) {
  resetPwdBtn.addEventListener('click', async(e) => {
    e.preventDefault();

    await new Promise(requestAnimationFrame);

    const emailInputGroup = document.querySelector(".login__user-data");
    const email = document.querySelector("#reset_email").value;
    const csrfToken = document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value;
    const resetPwdInfo = document.querySelector(".reset-pwd-output");
    const resetPwdBtnWrapper = document.querySelector(".reset-pwd-wrapper");

    try {
      const response = await fetch('/event-manager/reset-password', {
        method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({ 'email': email })
      });
    
      const data = await response.json();

      if( data.success ) {
        emailInputGroup.remove();
        resetPwdBtnWrapper.remove();
        resetPwdInfo.style.display = 'block';
        resetPwdInfo.innerHTML = `<span>En lenke for å tilbakestille passordet er sendt til ${email}</span>`;
        return;
      }

      const errorDiv = document.querySelector('.login__errors span');
      if (errorDiv)
          errorDiv.textContent = data.message;
    
    } catch( error ) {
      alert(`Reset password failed: ${error}`);
    }
  });
}
